/**
 * Centralized Icon Exports
 *
 * This file provides a single source of truth for all lucide-react-native icons
 * used throughout the application. Centralizing imports improves tree-shaking
 * and reduces bundle size by ensuring only used icons are included.
 *
 * @usage import { ChevronDown, Eye, EyeOff } from '../components/icons';
 */

export {
  // Navigation & UI Controls
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,

  // Actions
  Search,
  Copy,
  Edit,
  Edit3,
  // #1069 Story 7.3: "rename this conversation". `Edit` is taken -- it already
  // means "correct this message" in `MessageActions`.
  Pencil,
  Save,
  Trash2,
  Archive,
  Upload,
  Download,
  Share2,
  Filter,
  ArrowUpDown,
  RefreshCw,
  RotateCcw,
  Link2,

  // Audio & Recording
  Mic,
  Pause,
  Volume2,
  VolumeX,

  // File & Document Icons
  FileText,
  FileDown,
  Play,

  // File Type Icons (with aliases to avoid React Native conflicts)
  Image as ImageIcon,
  File as FileIcon,
  Video as VideoIcon,
  Type as TextIcon,

  // Visibility & Display
  Eye,
  EyeOff,
  Expand,
  Minimize,

  // Status & Alerts
  AlertCircle,
  AlertTriangle,
  CheckCircle,
  Check,
  X,
  XCircle,
  CloudOff,
  Calendar,
  Clock,

  // User & Security
  User,
  Users,
  UserPlus,
  Shield,
  ShieldCheck,
  Lock,
  Settings,
  Sliders,
  LogIn,
  LogOut,

  // Communication & Notifications
  Bell,
  Mail,
  MessageSquare,

  // Data Center & Infrastructure Icons
  Building2,
  Factory,
  Ruler,
  MapPin,
  Server,
  Package,
  Zap,
  Battery,
  Snowflake,
  Droplet,
  Laptop,

  // Feedback & Information
  Star,
  Info,
  ClipboardList,
  TestTube,

  // Attachments
  Camera,
  Paperclip,
  Plus,
  PlusCircle,

  // Layout & Organization
  List,
  Layers,
  GripVertical,
  MoreHorizontal,
} from 'lucide-react-native';

export { TextAssistPlaceholderIcon } from './TextAssistPlaceholder';
